
import {Component, Vue} from "vue-property-decorator";

import {ValidatableInterface} from "@/types/Validatable";

@Component({})
export default class Validatable extends Vue {
  validated = false;
  valid = false;

  async validate(silent = false) {
    this.validated = true;
    const validations = [];

    const filteredRefs = [];

    for(const [key,value] of Object.entries(this.$refs)) {
      const keySplit = key.split('.');

      if (keySplit[0] == 'validate' && value) {
        filteredRefs.push(value)
      }
    }


    for (const ref of filteredRefs as any[]) {
      if (typeof ref.validate === 'function') {
        const validationResult = await (ref as ValidatableInterface).validate(silent);
        validations.push(validationResult)
      }
    }

    const isValid = validations.reduce((result: boolean, entry: boolean) => {
      return result && entry
    }, true);

    this.valid = isValid;
    return isValid;
  }

  async reset() {
    const filteredRefs = [];

    for(const [key,value] of Object.entries(this.$refs)) {
      const keySplit = key.split('.');

      if (keySplit[0] == 'validate') {
        filteredRefs.push(value)
      }
    }


    for (const ref of filteredRefs as any[]) {
      if (typeof ref.reset === 'function') {
        (ref as ValidatableInterface).reset();
      }
    }
  }
}
